import {createSlice} from '@reduxjs/toolkit';

import MojitoCore from 'mojito/core';

const reduxInstance = MojitoCore.Services.redux;

export const STORE_KEY = 'DBX/VisualConfigStore';

export const INITIAL_STATE = {
    visualConfigHash: null,
};

export const {reducer, actions} = createSlice({
    name: STORE_KEY,
    initialState: INITIAL_STATE,
    reducers: {
        updateVisualConfigHash(state, {payload: newHash = null}) {
            state.visualConfigHash = newHash;
        },

        rebuildAndApplyVisualFromConfig() {},
    },
});

reduxInstance.injectReducer(STORE_KEY, reducer);

const selectState = state => {
    const appState = state || reduxInstance.store?.getState();

    return appState?.[STORE_KEY] || INITIAL_STATE;
};

export const selectVisualConfigHash = state => selectState(state).visualConfigHash;
